import { get } from "../../utils/objectHelpers";

static function removeProductCount(string) {
    return string.replace(/\([0-9^()]*\)/g, '').trim();
}

$ { 
    const buttonText = get(input, 'label', 'Shop by category');
}

<macro|{ category, index }| name="single-category">
    <li data-index=index class=`str-categories__single str-categories__${category._type}`>
        $ {
            const label = get(category, "label", {});
            const labelText = get(label, "textSpans.0.text", '');
            const action = get(category, "action", null);
            const url = get(action, "URL", '');
            const isAjax = get(action, "clientPresentationMetadata.ajax") === "true";
            const trackingData = JSON.stringify(get(category, "action.trackingList.0", {}));
            const accessibilityText = removeProductCount(get(label, "textSpans.0.text", ""));
        }
        <div class="str-categories__single--current">
            <if(isAjax)>
                <ebay-button on-click("fetchCategoryListings", url)
                    class="str-categories__single--option"
                    data-track=trackingData
                    variant="fake-link">
                    ${labelText}
                </ebay-button>
            </if>
            <else>
                <str-textual-display
                    ...label
                    tabindex="-1"
                    action=action
                    customParser=removeProductCount
                    accessibilityText=accessibilityText
                    class="str-categories__single--option"
                />
            </else>
            <if(category.categories)>
                <ebay-button
                    class="str-categories__toggle-collapse"
                    variant="icon"
                    tabindex="-1"
                    on-click("toggleCategoryChildren", category._type)
                ><ebay-chevron-right-small-icon /></ebay-button>
            </if>
            <else>
                <ebay-button
                    class="str-categories__toggle-collapse str-categories__toggle-collapse--fake"
                    variant="icon"
                    tabindex="-1"
                ><ebay-chevron-right-small-icon /></ebay-button>
            </else>
        </div>
        <if(category.categories)>
            <div class="str-categories__sub-list">
                <ebay-button
                    aria-label=accessibilityText
                    class="str-categories__sub-toggle-collapse"
                    variant="icon"
                    on-click("toggleCategoryChildren", category._type)
                >
                    <ebay-chevron-left-small-icon />
                    <str-textual-display ...label customParser=removeProductCount />
                </ebay-button>
                <ul tabindex=`${state.open ? "0" : "-1"}` role="list">
                    <for|subCategory, idx| of=category.categories>
                        <single-category category=subCategory index=idx />
                    </for>
                </ul>
            </div>
        </if>
    </li>
</macro>

<ebay-button class="str-categories__button" variant="icon" on-click("openCategories")>
    <span>${buttonText}</span>

    <!-- <ebay-categories-icon class="str-categories__button--mobile" /> -->
    <ebay-dropdown-icon class="str-categories__button--desktop" />
</ebay-button>
<section class=`str-categories__wrapper ${state.open ? "str-categories__wrapper--open" : ""}`>
    <div class="str-categories__wrapper-container">
        <div class=`str-categories ${state.focusDisabled ? "str-categories--focus-disabled" : ""}`>
            $ {
                const back = get(input, "back", {});
                const header = get(input, "header", {});
                const categories = get(input, "categories", []);
                const labelText = get(input, "header.textSpans.0.text", '');
                const url = get(input, "header.action.URL", '');
                const trackingData = JSON.stringify(get(input, "header.action.trackingList.0", {}));
                const isAjax = get(input, "header.action.clientPresentationMetadata.ajax") === "true";
            }
            <div class="str-categories__back">
                <ebay-button
                    variant="icon"
                    on-click("openCategories")
                >
                    <ebay-arrow-left-small-icon />
                </ebay-button>
                <h3>${buttonText}</h3>
            </div>
            <div class="str-categories__small-wrapper">
                <div class="str-categories__header">
                    <if(isAjax)>
                        <ebay-button on-click("fetchCategoryListings", url)
                            data-track=trackingData
                            variant="fake-link">
                            ${labelText}
                        </ebay-button>
                    </if>
                    <else>
                        <str-textual-display ...header />
                    </else>
                    <ebay-button
                        class="str-categories__toggle-collapse str-categories__toggle-collapse--fake"
                        variant="icon"
                        tabindex="-1"
                    ><ebay-chevron-right-small-icon /></ebay-button>
                </div>
                <ul class="str-categories__list" tabindex=`${state.open ? "0" : "-1"}` role="list">
                    <for|category, idx| of=categories>
                        <single-category category=category index=idx />
                    </for>
                </ul>
            </div>
        </div>
    </div>
</section>
